import { render, staticRenderFns } from "./Color_panel.vue?vue&type=template&id=68ca19eb&scoped=true&"
import script from "./Color_panel.vue?vue&type=script&lang=js&"
export * from "./Color_panel.vue?vue&type=script&lang=js&"
import style0 from "./Color_panel.vue?vue&type=style&index=0&id=68ca19eb&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca19eb",
  null
  
)

component.options.__file = "Color_panel.vue"
export default component.exports